import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import randomstring from 'uuid/v4';

import Grid from '@material-ui/core/Grid';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import BlueButton from '../../../buttons/BlueButton';
import Provider from './Provider';

const pagination = 15;

function sortData(arr, search) {
    if (!arr) {
        return arr;
    } else {
        const result = []
            .concat(arr)
            .sort((a, b) =>
                a.nombre.toUpperCase().trim() < b.nombre.toUpperCase().trim() ? -1 : 1,
            )
            .reduce((arr, info) => {
                if (search && search.length > 0) {
                    const filter = search.filter(
                        (s) => info.nombre && info.nombre.toUpperCase().includes(s),
                    );
                    if (filter && filter.length > 0) {
                        arr.push(<Provider key={randomstring()} provider={info} />);
                    }
                } else {
                    arr.push(<Provider key={randomstring()} provider={info} />);
                }
                return arr;
            }, []);
        return result;
    }
}

class ListProviders extends React.Component {
    state = {
        index: 0,
        providers: sortData(this.props.providers, this.props.window_searchs),
        window_searchs: this.props.window_searchs,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.providers !== state.providers || props.window_searchs !== state.window_searchs) {
            state.window_searchs = props.window_searchs;
            state.providers = sortData(props.providers, props.window_searchs);
            return state;
        }
        return null;
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleClick = (event) => {
        this.setState({ index: this.state.index + pagination });
    };

    render() {
        const { index, providers } = this.state;
        const { providers_is_loading, providers_has_errored } = this.props;
        const data = [...providers].splice(0, index + pagination);
        const length = providers.length;

        if (providers_has_errored.hasErrored) {
            return (
                <Error open type={providers_has_errored.hasErrored}  message={providers_has_errored.error} handleClose={this.handleBack} />
            );
        } else if (!providers_is_loading && providers === undefined) {
            return (
                <Error
                    open
                    message={<FormattedMessage id="error_providers_not_found" />}
                    handleClose={this.handleBack}
                />
            );
        } else {
            return (
                <div className={'flex_full_column padding_bottom_9 padding_top_12 height100'}>
                    {providers_is_loading && <Loading open opacity />}
                    <div className="flex_full overflow_y_scroll">
                        {data.map((u) => {
                            return u;
                        })}
                        {length > index + pagination && (
                            <Grid
                                container
                                justify="center"
                                className={'flex_grow_1 align_center margin_top_24'}
                            >
                                <Grid item xs={10} sm={6} className="padding_bottom_12">
                                    <BlueButton id="next" onClick={this.handleClick} />
                                </Grid>
                            </Grid>
                        )}
                    </div>
                </div>
            );
        }
    }
}

ListProviders.propTypes = {
    providers: PropTypes.array.isRequired,
    providers_is_loading: PropTypes.bool.isRequired,
    providers_has_errored: PropTypes.object.isRequired,
    window_searchs: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        providers: state.providers,
        providers_is_loading: state.providers_is_loading,
        providers_has_errored: state.providers_has_errored,
        window_searchs: state.window_searchs,
    };
};

export default connect(
    mapStateToProps,
    undefined,
)(withRouter(ListProviders));



// WEBPACK FOOTER //
// ./src/components/complex/manage/providers/List.js